import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { SELECTION_MODE_HASH } from '../constants';

export const useUrlSelectionMode = () => {
  const { hash, pathname } = useLocation();
  const navigate = useNavigate();

  const urlContainsSelectionMode = hash === SELECTION_MODE_HASH;

  useEffect(() => {
    if (urlContainsSelectionMode) {
      navigate(pathname, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    urlContainsSelectionMode,
  };
};
